import { defineMessages } from 'react-intl';

export default defineMessages({
    addServiceAmountTitle: {
        id: 'ax_servicerequest.views.update.amount.service.addServiceAmountTitle',
        defaultMessage: 'Add service amount'
    },
    totalAmountField: {
        id: 'ax_servicerequest.views.update.amount.service.totalAmountField',
        defaultMessage: 'Total amount'
    },
    currencyTypeField: {
        id: 'ax_servicerequest.views.update.amount.service.currencyTypeField',
        defaultMessage: 'Currency type'
    },
    cancel: {
        id: 'ax_servicerequest.views.update.amount.service.cancel',
        defaultMessage: 'Cancel'
    },
    send: {
        id: 'ax_servicerequest.views.update.amount.service.send',
        defaultMessage: 'Send'
    },
    error: {
        id: 'ax_servicerequest.views.update.amount.service.error',
        defaultMessage: 'Service amount update failed'
    },
    errorMessage: {
        id: 'ax_servicerequest.views.update.amount.service.errorMessage',
        defaultMessage: 'Sorry, we were unable to update the service amount. Please try again later or contact your system administrator'
    }
});
